import React, { Fragment, useState } from "react";
import DatePicker from "react-datepicker";
import { CustomPostAPI } from "../Utils/APIConnector";
import { result } from "lodash";
import Swal from "sweetalert2";

export default function TransactionHistory({ venueId }) {
  const [startDate, setStartDate] = useState(new Date(new Date().setDate(1)));
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const raw = JSON.stringify({
        venueid: venueId,
        StartDate: startDate,
        EndDate: endDate,
      });
      await CustomPostAPI(`/GenerateCSV/GenerateCSV`, raw).then((result) => {
        result = JSON.parse(result);
        if (result && result?.status == "Success") {
          const data = result?.csvData;
          if (!data.length) {
            Swal.fire({
              icon: "warning",
              title: "No Record Found",
              text: "We couldn’t find any records for the selected dates.Please pick a different time frame.",
            });
            return;
          }
          const originalHeaders = Object.keys(data[0]);
          const capitalizedHeaders = originalHeaders.map(
            (key) => key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()
          );

          const csvRows = [
            capitalizedHeaders.join(","),
            ...data.map((row) =>
              originalHeaders
                .map(
                  (field) =>
                    `"${(row[field] ?? "").toString().replace(/"/g, '""')}"`
                )
                .join(",")
            ),
          ];
          const csvContent = "\uFEFF" + csvRows.join("\n");
          const blob = new Blob([csvContent], { type: "text/csv" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "BookingReport.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Fragment>
      <div className="row mt-3">
        <div className="col-6 fw-semibold">
          Start Date:
          <DatePicker
            showIcon
            className="form-control profileformControl mt-1"
            icon="fa fa-calendar"
            selected={startDate}
            onChange={(e) => setStartDate(e)}
            placeholderText="Start"
            maxDate={new Date()}
            utcOffset={0}
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="col-6 fw-semibold">
          End Date:
          <DatePicker
            showIcon
            className="form-control profileformControl mt-1"
            icon="fa fa-calendar"
            selected={endDate}
            onChange={(e) => setEndDate(e)}
            placeholderText="End"
            maxDate={new Date()}
            utcOffset={0}
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="col-12 text-center mt-3">
          <button
            className="packageDetailsBtn"
            onClick={() => {
              !isLoading && handleDownload();
            }}
          >
            Download{" "}
          </button>
          {isLoading && (
            <img className="img-fluid ms-2" src="/images/loder.svg" />
          )}
        </div>
      </div>
    </Fragment>
  );
}
